import './App.css';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Tracking from './page/Tracking';
import ContainerDamage from './page/ContainerDamage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route>
          <Route path="/" element={<Tracking/>}/>
          <Route path="containerdamage" element={<ContainerDamage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
